
<ap-tiny-editor
            [formControl]="innerControl"
            [apCVAViewToModelChange]="this"
            [height]="height"
            [hideToolbar]="hideToolbar"
            [hideStatusBar]="hideStatusBar"
            [editorName]="editorName"
            [autoResize]="autoResize"
            [autoResizeMaxHeight]="autoResizeMaxHeight"
            [autoResizeMinHeight]="autoResizeMinHeight"
            [setFocusOnInit]="setFocusOnInit"
            [setFocusOnInitCursorAtEnd]="setFocusOnInitCursorAtEnd"
            [displayName]="displayName"
            (editorValueChanged)="onEditorValueChanged($event)"
            (editorValueChangedTextOnly)="onEditorValueChangedTextOnly($event)"
            (dirtyChanged)="onDirtyChanged()"
            #apTinyEditor>
</ap-tiny-editor>
